
import { motion, AnimatePresence } from "framer-motion";
import VideoGuide from "./video-guide";
import Button from "components/button/button";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { onboarding_WELCOME_VIDEO } from "utils/constant";

const ToolTipVid = ({show=false, title, desc, onClick =()=>{},video=onboarding_WELCOME_VIDEO})=>{
    const {t} = useTranslation();
    const [dontShowVid,setShowVid] = useState(false);
    const [showTut, setShowTut] = useState(show);

    const gotItHandler = ()=>{
        onClick(dontShowVid);
        setShowTut(false)
    }
    return (
        <AnimatePresence>
            {
            showTut?
                <motion.div
                    initial={{ opacity: 0, scale: 0.60 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.60 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="absolute top-[0] right-4 2smd:-right-[25rem] bg-white w-[20rem] 2smd:w-[24rem] rounded-md z-[99999]">
                    <div className="">
                        <div className="px-4 py-3 rounded-md relative">
                            <div className="flex justify-between items-center">
                                <h2 className="font-semibold text-lg">
                                    {title}
                                </h2>
                                <span className="close" onClick={() => setShowTut(false)}></span>
                            </div>
                            <p className="text-[0.9rem] mt-2">
                                {desc()}
                            </p>
                            <div className="overflow-hidden mt-4">
                                <VideoGuide
                                    className="w-full h-[20vh]"
                                    vidLink={video}
                                />
                            </div>
                            <div className="flex gap-2 my-4">
                                <div>
                                    <CustomCheckbox
                                        checked={dontShowVid}
                                        name="video"
                                        onChange={(e) => setShowVid(e?.target?.checked)}
                                        isBoxType={true}
                                    /> 
                                </div>
                                <p className="text-base">{t('DontShowAgain')}</p>
                            </div>
                            <Button
                                onClick={gotItHandler}
                                buttonName={t('gotIt')}
                                buttonClass="py-2 px-4 bg-gray w-full mt-2"
                                buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                            />
                            <div
                                className={`hidden 2smd:block absolute z-0 -left-[0.5rem] top-[18px] w-4 h-4 bg-white transform rotate-45 -transalte-x-1/2`}
                            ></div>
                        </div>
                    </div>
                </motion.div>
                : null
            }
        </AnimatePresence>
    )
}

export default ToolTipVid;